import { FC, useEffect } from 'react';
import { useRoutes, useNavigate } from 'react-router-dom';
import { Router } from 'src/content/router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuth0Client } from './api/apiUtils';
import { NotificationProvider } from './contexts/NotificationContext';

export const App: FC = () => {
  const auth0 = useAuth0();
  const content = useRoutes(Router());
  const navigate = useNavigate();

  useEffect(() => {
    setAuth0Client(auth0);
  }, [auth0]);

  useEffect(() => {
    if (!auth0.isLoading && auth0.isAuthenticated) {
      const returnTo = sessionStorage.getItem('returnTo');
      if (returnTo) {
        sessionStorage.removeItem('returnTo');
        navigate(returnTo);
      }
    }
  }, [auth0.isLoading, auth0.isAuthenticated, navigate]);

  if (auth0.isLoading) {
    return <div data-testid="loading-indicator">Loading...</div>;
  }

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <CssBaseline />
        <NotificationProvider>
          {content}
        </NotificationProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};
